export default __webpack_public_path__ + "static/media/error.e405616a.jpg";